import { createAsyncThunk } from "@reduxjs/toolkit";
import { statusConst } from "../../const";
import { fetchUserAuthInfo } from "../../api/authApi";
import { fetchCurrentCompany } from "../../auth/authHelper";

// Store auth details at page refresh.
export const loadPermissions = createAsyncThunk("loadPermissions", async () => {
  try {
    const {
      username,
      permissions,
      companies,
      types,
      userDetails,
      currentCompany,
    } = await fetchUserAuthInfo();
    let permissionsMap = permissions ? JSON.parse(permissions) : {};

    // Dynamically inject BANK_MASTER permissions since it's not in the auth database yet
    if (!permissionsMap["masterdata"]) {
      permissionsMap["masterdata"] = {};
    }
    permissionsMap["masterdata"]["VIEW"] = true;
    permissionsMap["masterdata"]["BANK_MASTER"] = {
      FORM: {
        CREATE: true,
        UPDATE: true,
        VIEW: true,
        DELETE: true,
      },
      bnk_code: { VIEW: true, CREATE: true, UPDATE: true },
      bnk_referance: { VIEW: true, CREATE: true, UPDATE: true },
      bnk_name: { VIEW: true, CREATE: true, UPDATE: true },
      bnk_description: { VIEW: true, CREATE: true, UPDATE: true },
      bnk_company: { VIEW: true, CREATE: true, UPDATE: true },
      bnk_status: { VIEW: true, CREATE: true, UPDATE: true },
      bnk_active: { VIEW: true, CREATE: true, UPDATE: true },
    };

    const companyIds = companies ? companies.map((com) => com.comId) : [];

    return {
      username,
      needAuth: false,
      permissions: permissionsMap,
      company: companies,
      types,
      userDetails,
      currentCompany: currentCompany,
      companyIds,
      permissionStatus: statusConst.SUCCESS,
      isLoading: false,
    };
  } catch (e) {
    console.error(e);
    // Reject so permissionStatus becomes FAILURE and AuthGuard can redirect
    // instead of rendering with an empty permission set.
    throw e;
  }
});

// Store auth details at authentication and token refresh.
export const storeAuthDetails = createAsyncThunk(
  "storeAuthDetails",
  async (response) => {
    return {
      ...response,
      authenticated: true,
      needAuth: false,
      permissionStatus: statusConst.SUCCESS,
      isLoading: false,
    };
  },
);
